import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { GetWidgetsResponse } from './getWidgets.types'

export const getWidgets = async () => {
  const response =
    await containerApi.get<GetWidgetsResponse>('/desktop/widgets')
  return response.data.data
}

export const GET_WIDGETS_QUERY_KEY = 'getWidgets'

export const useGetWidgetsQuery = (
  options?: ExtendableQueryOptions<GetWidgetsResponse['data']>
) => {
  return useQuery({
    queryKey: [GET_WIDGETS_QUERY_KEY],
    queryFn: getWidgets,
    ...options
  })
}
